import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { getInvoicePaymentsReport } from "../../../actions/report";
import { getAllLocationPlain } from "../../../actions/warehouseAction";
import { getAllAccount } from "../../../actions/accountsAction";
import moment from "moment";
import dateFormat from "dateformat";

import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  DatePicker,
  Select,
  Divider,
  Skeleton,
  Button,
  AutoComplete,
  Spin,
  Table,
} from "antd";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const InvoicePaymentsReport = ({
  getInvoicePaymentsReport,
  getAllLocationPlain,
  getAllAccount,
  businessprofile,
  Auth,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [accounts, setaccounts] = useState([]);
  const [outletlist, setoutletlist] = useState([]);
  const [loading, setloading] = useState(true);
  const [reload, setreload] = useState(false);
  const [dates, setDates] = useState([]);

  const start = useRef("");
  const end = useRef("");
  const keyward = useRef("");
  const account = useRef("");
  const location = useRef(
    Auth.profile.branch.is_outlet ? Auth.profile.branch.id : ""
  );
  const month = useRef("");
  const year = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(100);
  let total_data = useRef({});

  useEffect(() => {
    getAllLocationPlain().then((result) => {
      console.log("getAllLocationPlain", result);
      setoutletlist(result);
    });

    getAllAccount().then((result) => {
      console.log("getAllAccount", result);
      setaccounts(result);
    });

    getInvoicePaymentsReport(
      start.current,
      end.current,
      keyward.current,
      "",
      location.current,
      month.current,
      year.current,
      account.current,
      Auth.Protected ? true : "",
      pageno.current,
      page_size.current
    ).then(function (result) {
      // console.log("getInvoicePaymentsReport:", result);
      total_data.current = {
        total_payments: result.count,
        total_bill: result.total_bill,
        total_payment: result.total_payment,
        total_due: result.total_due,
        total_receive: result.total_receive,
        total_refund: result.total_refund,
        total_discount: result.total_discount,
        total_tax: result.total_tax,
        total_advance_payment: result.total_advance_payment,
        total_quantity: result.total_quantity,
        current_page_bill: result.current_page_bill,
        current_page_payment: result.current_page_payment,
        current_page_due: result.current_page_due,
        current_page_receive: result.current_page_receive,
        current_page_refund: result.current_page_refund,
        current_page_discount: result.current_page_discount,
        current_page_tax: result.current_page_tax,
        current_page_advance_payment: result.current_page_advance_payment,
        current_page_quantity: result.current_page_quantity,
      };
      setData(result);
      setloading(false);
    });
  }, [reload]);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
    }
  };

  const columns = [
    {
      title: "SL",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Payment Date",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Method",
      dataIndex: "account_name",
      key: "account_name",
      // render: (invoice) => invoice.Payment_method || "N/A",
    },
    // {
    //   title: "Method",
    //   dataIndex: "invoice",
    //   key: "payment_method",
    //   render: (invoice) => invoice.Payment_method || "N/A",
    // },
    {
      title: "Invoice No.",
      dataIndex: "invoice",
      key: "invoice_number",
      render: (invoice) => (invoice && invoice.invoice_number) || "N/A",
    },
    {
      title: "Contact",
      dataIndex: "invoice",
      key: "contact",
      render: (invoice) => {
        if (!invoice) return "N/A";

        const contact = Array.isArray(invoice.Contact) ? invoice.Contact[0] : null;

        return contact.phone || "N/A";
      },
    },
   
    {
      title: "Cash In",
      dataIndex: "payment",
      key: "cash_in",
      render: (text, record) => {
        const val = parseFloat(record.payment || 0);
        return formatter.format(val > 0 ? val : 0);
      },
    },
    {
      title: "Cash Out",
      dataIndex: "payment",
      key: "cash_out",
      render: (text, record) => {
        const val = parseFloat(record.payment || 0);
        return formatter.format(val < 0 ? Math.abs(val) : 0);
      },
    },
    // {
    //   title: "Receive",
    //   dataIndex: "receive",
    //   key: "receive",
    //   render: (text) => formatter.format(text || 0),
    // },
    // {
    //   title: "Due",
    //   dataIndex: "due",
    //   key: "due",
    //   render: (text) => formatter.format(text || 0),
    // },

    // {
    //   title: "Tax",
    //   dataIndex: "tax",
    //   key: "tax",
    //   render: (text) => formatter.format(text || 0),
    // },
    // {
    //   title: "Advance",
    //   dataIndex: "advance_payment",
    //   key: "advance_payment",
    //   render: (text) => formatter.format(text || 0),
    // },
  ];

  const handleTableChange = (pagination) => {
    pageno.current = pagination.current;
    page_size.current = pagination.pageSize;
    setloading(true);
    setreload(!reload);
  };

  const SwitchablePicker = () => {
    return (
      <Row wrap={false} gutter={[8, 8]}>
        <Col span={3}>
          <h5>Keyword:</h5>
          <AutoComplete
            placeholder="Search..."
            onKeyUp={onChange}
            style={{ width: "100%", minWidth: "140px" }}
          />
        </Col>
        <Col span={3}>
          <h5>Account:</h5>
          <Select
            placeholder="Payment Account"
            style={{ width: "100%" }}
            onChange={(e) => {
              account.current = e;
            }}
          >
            <Option value="">All</Option>
            {accounts.map((acc) => (
              <Option key={acc.id} value={acc.id}>
                {acc.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={5}>
          <h5>Payment Date:</h5>
          <RangePicker
            style={{ width: "100%" }}
            disabledDate={(current) => {
              // 1. If actively picking on the calendar
              if (dates && dates.length > 0 && dates[0]) {
                return !current.isSame(dates[0], "month");
              }
              // 2. If panel is opened but range was already selected
              if (start.current) {
                const fromMoment = moment(start.current.split("T")[0], "YYYY-MM-DD");
                return !current.isSame(fromMoment, "month");
              }
              return false;
            }}
            onCalendarChange={(val) => setDates(val)}
            onChange={(value) => {
              if (value) {
                start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
              } else {
                start.current = "";
                end.current = "";
              }
              setDates(null);
            }}
          />
        </Col>
        <Col span={2}>
          <h5>Month:</h5>
          <Select
            placeholder="Month"
            style={{ width: "100%" }}
            onChange={(e) => {
              month.current = e;
            }}
          >
            <Option value="">All</Option>
            {[...Array(12)].map((_, i) => (
              <Option key={i + 1} value={i + 1}>
                {moment().month(i).format("MMMM")}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={2}>
          <h5>Year:</h5>
          <Select
            placeholder="Year"
            style={{ width: "100%" }}
            onChange={(e) => {
              year.current = e;
            }}
          >
            <Option value="">All</Option>
            {[...Array(10)].map((_, i) => {
              const y = moment().year() - i;
              return (
                <Option key={y} value={y}>
                  {y}
                </Option>
              );
            })}
          </Select>
        </Col>
        <Col span={3}>
          <h5>Outlet:</h5>
          <Select
            placeholder="Select outlet"
            style={{ width: "100%" }}
            defaultValue={
              Auth.profile.branch.is_outlet ? Auth.profile.branch.id : ""
            }
            disabled={!Auth.superuser}
            onChange={(e) => {
              location.current = e;
            }}
          >
            <Option value="">All</Option>
            {outletlist.map((outlet) => (
              <Option key={outlet.id} value={outlet.id}>
                {outlet.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={2}>
          <h5 style={{ color: "white" }}>.</h5>
          <Button
            type="primary"
            style={{ width: "100%" }}
            onClick={() => {
              pageno.current = 1;
              setloading(true);
              setreload(!reload);
            }}
          >
            Search
          </Button>
        </Col>
        <Col span={2}>
          <h5 style={{ color: "white" }}>.</h5>
          <ReactToPrint
            trigger={() => (
              <Button type="ghost" style={{ width: "100%" }}>
                Print
              </Button>
            )}
            content={() => componentRef.current}
          />
        </Col>
      </Row>
    );
  };

  const SummaryCards = () => {
    return (
      <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
        <Col span={6}>
          <div style={{ padding: "15px", background: "#f0f2f5", borderRadius: "8px" }}>
            <h4>Total Transaction</h4>
            <h2>{total_data.current.total_payments || 0}</h2>
          </div>
        </Col>
        <Col span={6}>
          <div style={{ padding: "15px", background: "#e6f7ff", borderRadius: "8px" }}>
            <h4>Total Payment</h4>
            <h2>{formatter.format(total_data.current.total_payment || 0)}</h2>
          </div>
        </Col>
        <Col span={6}>
          <div style={{ padding: "15px", background: "#f6ffed", borderRadius: "8px" }}>
            <h4>Cash In</h4>
            <h2>{formatter.format(total_data.current.total_receive || 0)}</h2>
          </div>
        </Col>
        <Col span={6}>
          <div style={{ padding: "15px", background: "#fff1f0", borderRadius: "8px" }}>
            <h4>Cash Out</h4>
            <h2>{formatter.format(total_data.current.total_refund || 0)}</h2>
          </div>
        </Col>
      </Row>
    );
  };

  const PrintableContent = () => {
    return (
      <div style={{ display: "none" }}>
        <div className="invoice_print_fontSize" ref={componentRef} style={{ padding: "20px" }}>
          <Row style={{ borderBottom: "2px solid lightgray", paddingBottom: "10px", marginBottom: "20px" }}>
            <Col span={17}>
              <small>
                <div
                  style={{ lineHeight: "2.5px" }}
                  dangerouslySetInnerHTML={{ __html: businessprofile.address }}
                ></div>
              </small>
            </Col>
            <Col span={7} style={{ textAlign: "right" }}>
              <img src={businessprofile.logo} style={{ maxHeight: "60px" }} />
            </Col>
          </Row>

          <h3 style={{ textAlign: "center" }}>Invoice Payments Report</h3>
          <Row style={{ marginBottom: "20px" }}>
            <Col span={12}>
              {start.current && (
                <>From: {dateFormat(start.current, "mmmm dS, yyyy")}<br /></>
              )}
              {end.current && (
                <>To: {dateFormat(end.current, "mmmm dS, yyyy")}<br /></>
              )}
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              {outletlist.map((outlet) => {
                if (outlet.id == location.current)
                  return <span key={outlet.id}>Outlet: {outlet.name}</span>;
              })}
            </Col>
          </Row>

          <table className="product_table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>SL</th>
                <th>Date</th>
                <th>Invoice No.</th>
                <th>Order No.</th>
                <th>Contact</th>
                <th>Bill</th>
                <th>Payment</th>
                <th>Receive</th>
                <th>Due</th>
                <th>Discount</th>
                <th>Tax</th>
              </tr>
            </thead>
            <tbody>
              {data.results && data.results.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.issue_date}</td>
                  <td>{(item.invoice && item.invoice.invoice_number) || "N/A"}</td>
                  <td>{(item.invoice && item.invoice.order_number) || "N/A"}</td>
                  <td>{(item.invoice && item.invoice.contact && item.invoice.contact.phone) || "N/A"}</td>
                  <td>{formatter.format(item.bill)}</td>
                  <td>{formatter.format(item.payment)}</td>
                  <td>{formatter.format(item.receive)}</td>
                  <td>{formatter.format(item.due)}</td>
                  <td>{formatter.format(item.discount)}</td>
                  <td>{formatter.format(item.tax)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ fontWeight: "bold" }}>
                <td colSpan={5}>Total:</td>
                <td>{formatter.format(total_data.current.total_bill)}</td>
                <td>{formatter.format(total_data.current.total_payment)}</td>
                <td>{formatter.format(total_data.current.total_receive)}</td>
                <td>{formatter.format(total_data.current.total_due)}</td>
                <td>{formatter.format(total_data.current.total_discount)}</td>
                <td>{formatter.format(total_data.current.total_tax)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  const Rendercontent = () => {
    if (loading) {
      return (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      );
    } else {
      return (
        <>
          <SummaryCards />
          <Divider />
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={data.results || []}
              rowKey="id"
              pagination={{
                current: pageno.current,
                pageSize: page_size.current,
                total: data.count,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total}`,
              }}
              onChange={handleTableChange}
              scroll={{ x: 1000 }}
            />
          </Spin>
          <PrintableContent />
        </>
      );
    }
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
        <Breadcrumb.Item>Invoice Payments</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row>
          <Col span={24} style={{ padding: "1rem", border: "1px solid whitesmoke" }}>
            {SwitchablePicker()}
            {Rendercontent()}
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getInvoicePaymentsReport,
  getAllLocationPlain,
  getAllAccount,
})(InvoicePaymentsReport);